import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { bearerTokenInterceptor } from './interceptors/bearer-token.interceptor';
import { initializeAuthFactory } from './services/auth-init.factory';
import { AuthService } from './services/auth.service';

// CUSTOM IMPORTS
// import { MapViewerService, Viewer3dService } from '@3ddv/ngx-dvm-internal';
// import { MinimapProvider, Viewer3dProvider, ViewerProvider } from  '@dvm.providers';
import { ViewerProvider, MinimapProvider, Viewer3dProvider } from './dvm.providers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([bearerTokenInterceptor])),

    //* New way to provide APP_INITIALIZER in Angular 19+
    provideAppInitializer(() => initializeAuthFactory(inject(AuthService))),
    //* Previous way to provide APP_INITIALIZER in Angular 18 and below
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initializeAuthFactory,
    //   // useFactory: AuthService.initializeAuthFactory,
    //   deps: [AuthService],
    //   multi: true,
    // },


    // DVM PROVIDERS

    ViewerProvider,
    MinimapProvider,
    Viewer3dProvider,

    // MapViewerService,
    // Viewer3dService,

  ]
};
